import angular from 'angular';
import modalConfirmationCart from '../../catalog/modal-confirmation/modal-confirmation.view.html';
import modalConfirmation from '../../shared/components/modal-response/modal-response.view.html';

let inject = [
    '$scope',
    '$state',
    '$rootScope',
    'ByFavoritesService',
    '$uibModal',
    'CartService',
    'SessionService',
    '$mdToast',
    'Pagination'
];

class ByFavoritesController {
    constructor($scope, $state, $rootScope, ByFavoritesService, $uibModal, CartService, SessionService, $mdToast, Pagination) {
        this.$scope = $scope;
        this.$state = $state;
        this.$rootScope = $rootScope;
        this.ByFavoritesService = ByFavoritesService;
        this.$uibModal = $uibModal;
        this.CartService = CartService;
        this.paginator = Pagination;
        this.$mdToast = $mdToast;
        this.loaded = false;
        this.SessionService = SessionService;
        this.products = [];
        this.searchingProducts = false;
        this.itemsPerPage = 10;
        this.pagination = {};
        this.sortType = 'name'
        this.sortReverse = false;
    }

    $onInit() {
        this.productsFavorites();
    }

    productsFavorites() {
        this.ByFavoritesService.getProductsFavorites(this.shCtrl.globals.currentUser.userId).then(response => {
            this.products = response;
            this.loaded = true;
            this.searchingProducts = false;
            this.pagination = this.paginator.getNew(this.itemsPerPage);
            this.pagination.numPages = Math.ceil(this.products.length / this.pagination.perPage);
        }).catch(error => {
            console.log(error)
        })
    }

    doFastSearch(searchText) {
        if (angular.isDefined(searchText) && !angular.equals('')) {
            this.searchingProducts = true;
            this.ByFavoritesService.getProducts(searchText, this.shCtrl.globals.currentUser.userId).then(response => {
                this.products = response;
                this.searchingProducts = false;
                this.pagination = this.paginator.getNew(this.itemsPerPage);
                this.pagination.numPages = Math.ceil(this.products.length / this.pagination.perPage);
            }).catch(error => {
                console.log(error)
            })
        }
    }

    setPagination(itemsPerPage) {
        this.itemsPerPage = itemsPerPage;
        this.pagination = this.paginator.getNew(this.itemsPerPage);
        this.pagination.numPages = Math.ceil(this.products.length / this.pagination.perPage);
    }

    decreaseProductQuantity(product) {
        if (product.quantityCart > 1)
            product.quantityCart--;
    }

    increaseProductQuantity(product) {
        product.quantityCart++;
    }

    addItemToCart(product) {
        if (product.id) {
            let userId = '',
                cart = null;
            try {
                userId = this.shCtrl.globals.currentUser.userId;
            } catch (e) {
            }
            try {
                cart = this.shCtrl.cart;
            } catch (e) {
            }


            let validation  = this.SessionService.validateFactorItems(product.quantityCart,product);
   
            if(validation.error){

                let options = {
                    title: '',
                    isHtml: true,
                    content: validation.message,
                    size: '',
                    showBottonCancel: false,
                    textActionCancel: '',
                    textAction: 'Aceptar'
                };
                this.messageResponse(options);
                return;
            }


            this.CartService.addItemToCart(product, product.quantityCart, null, null, userId, cart).then(response => {
                if (!response.error) {
                    // this.$scope.$emit('onUpdateCart');

                    // let modalInstance = this.$uibModal.open({
                    //   animation: true,
                    //   template: modalConfirmationCart,
                    //   controller: 'ModalConfirmationController',
                    //   controllerAs: 'mdCtrl',
                    //   size: 'lg',
                    //   resolve: {
                    //     product: () => product
                    //   }
                    // });

                    this.dataCart = {};
                    this.dataProducs = {};

                    this.modalConfirmation(product,product.quantityCart);


                } else {
                    if (response.agotado) {
                        product.cantidad = response.itemStock;
                        this.CartService.updateItemsNotAvailable(product, product.quantityCart, userId);
                    }


                    let options = {
                        title: '',
                        isHtml: true,
                        content: response.message,
                        size: '',
                        showBottonCancel: false,
                        textActionCancel: '',
                        textAction: 'Aceptar'
                    };
                    this.messageResponse(options);
                }
            }).catch(reason => {
                let options = {
                    title: '',
                    isHtml: false,
                    content: reason,
                    size: '',
                    showBottonCancel: false,
                    textActionCancel: '',
                    textAction: 'Aceptar'
                };
                this.messageResponse(options);
            })
        }
    }

    updateFavoriteProducts(product) {
        product.isSettingAsFavorite = true;
        let userId = '';
        try {
            userId = this.shCtrl.globals.currentUser.userId;
        } catch (e) {
        }
        if (userId) {
            let data = {
                'productId': product.id,
                'userId': userId,
                'setFavorite': !product.isFavorite
            };

            this.ByFavoritesService.updateFavoriteProducts(data).then(response => {

                if (!response.error) {
                    this.ByFavoritesService.getResumeProductsFavorites(this.shCtrl.globals.currentUser.userId).then(favoritesResponse => {
                        this.shCtrl.globals.currentUser.favoriteItems = favoritesResponse;
                        this.SessionService.put('globals', this.shCtrl.globals);

                    });
                }

                product.isFavorite = !product.isFavorite;
                product.isSettingAsFavorite = false;


            }).catch(error => {
                product.isSettingAsFavorite = false;
                let options = {
                    title: '',
                    isHtml: false,
                    content: 'Ha ocurrido un error al actualizar el producto',
                    size: '',
                    showBottonCancel: false,
                    textActionCancel: '',
                    textAction: 'Aceptar'
                };
                this.messageResponse(options);
            });
        }
    }

    messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
        let modalInstance = this.$uibModal.open({
            animation: true,
            template: modalConfirmation,
            controller: 'ModalResponseController',
            controllerAs: 'mdCtrl',
            size: options.size,
            resolve: {
                modalOptions: () => options
            }
        });
        modalInstance.result.then(() => {
            if (callAcept) {
                callback();
            }
        }).catch(reason => {
            if (callCancel) {
                callbackCancel();
            }
        });
    }

    modalConfirmation(products, quantity) {

        this.productAdded = products;
        this.productAdded.image = products.imagesDetail[0].path + products.imagesDetail[0].image;
        this.productAdded.price = products.itemPrice;
        this.productAdded.discount = products.discountValue;
        this.productAdded.ivaValue = products.taxValue;
        this.productAdded.quantity = quantity;
        this.productAdded.total = (products.itemPrice - products.discountValue + products.taxValue) * quantity;

        if (__env.adaptative) {
            this.messageMaterial(products.name + ' Ha sido agregado correctamente')
        } else {
            $('#ModalproductDetail').modal('toggle');
        }

        this.$scope.$emit('onUpdateCart', 'modalResponseItems');
    }

    messageMaterial(text) {
        var mdToast = this.$mdToast;
        this.$mdToast.show({
            hideDelay: 7000,
            controller: function () {
                this.closeToast = function () {
                    mdToast.hide();
                }

            },
            controllerAs: 'toast',
            template: '<md-toast>\n' +
            '  <span class="md-toast-text">' + text + '</span>\n' +
            '  <md-button ng-click="toast.closeToast()">\n' +
            '    Cerrar\n' +
            '  </md-button>\n' +
            '</md-toast>'
        });
    }
}

ByFavoritesController.$inject = inject;

export default ByFavoritesController;



// WEBPACK FOOTER //
// ./www/components/fast-purchase/by-favorites/by-favorites.controller.js